import { route } from './experience/route';
import { dataSources } from './component/data-sources.listener';
import { layoutManager } from './component/layout-manager.listener';
import { experienceSSR } from './experience/experience-ssr';
import { customVariables } from './experience/custom-variables';
import { timeouts } from './experience/timeouts';

const NewRelicBridge = {
  init: () => {
    if (typeof window === 'undefined') return;

    try {
      // reports all api errors
      dataSources();
      // reports all component errors that failed to layout
      layoutManager();
      customVariables();
      experienceSSR();
      timeouts();
    } catch (err) {
      console.log(err);
    }

  }
};

export { NewRelicBridge };
